<script>
    export default {
        name: 'StorageMixin',
        data: () => ({
            token:null
        }),
        created(){
            this.token = this.getToken()
        },
        methods: {
            setToken(token){
                this.token = token
                return localStorage.setItem('token', token)
            },
            getToken(){ return localStorage.getItem('token') },
            removeToken(token){
                this.token = null
                return localStorage.removeItem('token')
            }
        },
    }
</script>